<template>
  <div :class="$style.skeleton"></div>
</template>

<style module lang="postcss">
.skeleton {
  @apply bg-bg-secondary/70;
  border-radius: 8px;
  animation: shimmer-pulse 1.8s infinite;
  position: relative;
  overflow: hidden;

  @media (min-width: 375px) {
    animation: none;

    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        90deg,
        transparent 0%,
        rgba(255, 255, 255, 0.3) 50%,
        transparent 100%
      );
      animation: shimmer 1.8s infinite;
      will-change: transform;
    }
  }
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

@keyframes shimmer-pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
</style>
